import React from "react";

export function OrganiserDeclined({ thread }) {
  return (
    <>
      The venue has declined your enquiry. Still looking for a venue for your
      event? You can see similar venues{" "}
      <a href={`/book-venue-${thread._space.url.split("/")[1]}`}>here</a>
    </>
  );
}

export function HostDeclined() {
  return "You have declined the enquiry";
}
